var app = angular.module('leonardo');

var FormSelectMultiple = function ($document, $filter, $q, $rootScope, $timeout, FilterService, UtilityService) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      filter: '@',
      name: '@',
      inline: '=',
      placeholder: '@',
      options: '=?',
      noMultiple: '=',
      allClean: '=',
      autoClose: '=',
      hideList: '=',
      modeUser: '=?',
      mode: '@',
      modeInput: '@',
      returnObject: '=?',
      defaultValues: '=?',
      validOptions: '=?',
      labelAll: '@',
      ngChange: '&',
      service: '=?',
      serviceParams: '=?',
      serviceFunction: '=?',
      showEmail: '=?',
      validators: '=?',
      allowUncheck: '=ngAllowUncheck',
      nameField:'@',
      removeItem: '@'
    },
    templateUrl: 'views/templates/form/form-select-multiple.html',
    link: function (scope, elem, attrs, ctrl) {
      scope.ngModelCtrl = ctrl[0];
      scope.formCtrl = scope.$parent.Form ? scope.$parent.Form : { $submitted: true };
      scope.name = scope.name ? scope.name : 'value';
      scope.click = false;
      scope.scroll = 0;
      scope.clickEvent = 'click.' + (scope.filter ? scope.filter : scope.name) + UtilityService.randomFloat() * 10;
      scope.notShowElements = attrs.notShowElements !== undefined && attrs.notShowElements !== 'false';
      scope.elementsSelected = [];
      scope.comboListVisible = false;
      scope.inputVisible = false;
      scope.filterValues = [];
      scope.all = false;
      scope.results = [];
      scope.options_results = [];
      scope.options_groups = [];
      scope.init_options = false;
      scope.groups = false;
      scope.limitResults = 25;
      scope.limitGroups = 5;
      scope.page = 1;
      scope.totalElements = 0;
      scope.reset = true;
      if (scope.allClean !== undefined) {
        scope.clean = scope.allClean;
      }
      else {
        scope.clean = scope.labelAll ? true : false;
      }
      if (!isEmpty(scope.validators)) {
        scope.validations = (angular.isArray(scope.validators) ? scope.validators : [scope.validators]);
      }
      else {
        scope.validations = [];
      }
      scope.externalValidationError = null;

      scope.showMoreResults = function () {
        if (scope.service && scope.limitResults < scope.totalElements) {
          scope.page++;
          scope.scroll = elem.find('.widget-combo-list').scrollTop();
          scope.getResults().then(function () {
            $timeout(function () {
              elem.find('.widget-combo-list').animate({ scrollTop: scope.scroll }, 0);
            });
          });
        } else {
          scope.limitResults += 25;
        }
      };

      scope.showMoreGroups = function () {
        scope.limitGroups = scope.options_groups.length;
      };

      scope.showInput = function () {
        return scope.inputVisible;
      };

      scope.getName = function (element) {
        let name = '';
        if (!angular.isObject(element)) {
          name = element;
        } else if(scope.nameField && element[scope.nameField]) {
          name = element[scope.nameField];
        } else if (element.name) {
          name = element.name;
        } else if (element.label) {
          name = element.label;
        } else if (element.number) {
          name = element.number;
        } else if (scope.modeUser) {
          let user = element.user || element;
          if (scope.showEmail) {
            name = !isNull($filter('username')(user)) ? $filter('username')(user) + ' (' + user.email + ')' : user.email;
          } else {
            name = !isNull($filter('username')(user)) ? $filter('username')(user) : user.email;
          }
        }
        return name;
      };

      scope.getNameElementSelected = function () {
        if (scope.notShowElements || !scope.hideList) {
          return scope.placeholder ? scope.placeholder : 'Select ' + scope.filter;
        } else  if (scope.$parent.lookup_filters) {
          let name = '';
          angular.forEach(scope.$parent.lookup_filters, function (element) {
            name += scope.getName(element) + ', ';
          });
          return name;
        }
        else {
          let name = '';
          if (scope.elementsSelected.length > 0) {
            angular.forEach(scope.elementsSelected, function (element) {
              name += scope.getName(element) + ', ';
            });
          } else {
            name += scope.placeholder ? scope.placeholder + ', ' : 'Select ' + scope.filter + ', ';
          }
          return name.slice(0, -2);
        }
      };

      scope.getGroup = function (group) {
        let result = null;
        angular.forEach(scope.options_groups, function (option) {
          if (option.group === group) {
            result = option;
          }
        });
        return result;
      };

      scope.getClasses = function () {
        let classes = [];
        if (!isNull(scope.filterValues) && scope.filterValues.length > 0) {
          classes.push('active');
        }
        if (scope.formCtrl.$submitted && scope.Field[scope.name].$invalid) {
          classes.push('has-error');
        }
        return classes;
      };

      scope.toggleComboList = function () {
        if (scope.disabled) {
          return;
        }
        scope.comboListVisible = !scope.comboListVisible;
        if (scope.comboListVisible) {
          $timeout(function () {
            if (!scope.inputVisible) {
              scope.focusInput();
            }
            elem.find('.widget-combo-list').animate({ scrollTop: scope.scroll }, 0);
          });
        } else {
          scope.inputVisible = false;
          scope.reset = false;
          scope.value_aux = '';
        }
      };

      scope.initGroups = function (options) {
        scope.options_groups = [];
        angular.forEach(angular.copy(options), function (option) {
          if (option && option.elements) {
            scope.options_groups.push(option);
          } else {
            if (!scope.getGroup('default')) {
              scope.options_groups.push({
                group: 'default',
                name: 'Default',
                elements: []
              });
            }
            scope.getGroup('default').elements.push(option);
          }
        });
      };

      scope.parseOptions = function (options) {
        let results = [];
        scope.groups = false;
        if (angular.isArray(options) && options.length > 0) {
          angular.forEach(options, function (option) {
            if (option && option.elements) {
              scope.groups = true;
              angular.forEach(option.elements, function (element) {
                results.push(element);
              });
            } else {
              results.push(option);
            }
          });
        } else {
          if (!isNull(options)) {
            results = (!angular.isArray(options) ? options.toString().split(',') : []);
          }
          else {
            results = options;
          }
        }
        if (scope.groups) {
          scope.initGroups(options);
        }
        return results;
      };

      scope.initOptions = function () {
        if (scope.results.length === 0) {
          if (scope.init_options) {
            scope.options_results = [];
          }
          return;
        }
        let options = [];
        let name = '';
        angular.forEach(scope.results, function (value, key) {
          if (!angular.isObject(value)) {
            if (scope.modeInput === 'index') {
              options.push({ id: key.toString(), name: value });
            } else {
              options.push({ id: value, name: value });
            }
          } else {
            name = scope.getName(value);
            let option = {
              id: scope.modeInput === 'index' ? key.toString() : value.id,
              name: name,
              resident_name: value.resident_name,
              resident_phone: value.resident_phone,
              resident_email: value.resident_email,
              resident_external_id: value.resident_external_id,
              required: value.required
            };
            if (scope.modeUser && scope.returnObject) {
              let user = value.user || value;
              option.first_name = user.first_name;
              option.last_name = user.last_name;
              option.email = user.email;
            }
            options.push(option);
          }
        });
        if (options.length > 0) {
          scope.results = options;
        }

        scope.options_results = angular.copy(scope.results);
        scope.init_options = true;
      };

      scope.initElementsSelected = function (options) {
        scope.elementsSelected = [];
        if (scope.filterValues.length > 0) {
          let valid_results = [];
          angular.forEach(scope.filterValues, function (value) {
            angular.forEach(options, function (element) {
              let element_id = !isNull(element.id) ? element.id.toString() : '';
              if (!_.contains(valid_results, element_id) && !isNull(element_id)) {
                if (value === element_id) {
                  scope.elementsSelected.push(element);
                  valid_results.push(element_id);
                }
              }
            });
          });
          scope.filterValues = valid_results;
        }
        scope.all = scope.isAllSelected();
      };

      scope.initElementsSelectedService = function () {
        let defer = $q.defer();
        scope.elementsSelected = [];
        if (scope.filterValues.length > 0) {
          let params = scope.serviceParams ? angular.copy(scope.serviceParams) : {};
          params.essential = true;
          params.noerror = true;
          params.id = scope.filterValues.join(',');
          scope.serviceFunction = scope.serviceFunction || scope.service.getlist;
          scope.serviceFunction(params, true).then(
            function (data) {
              let elementsIds = [];
              scope.elementsSelected = [];
              let results = data.results ? data.results : data;
              angular.forEach(results, function (element) {
                let element_id = !isNull(element.id) ? element.id.toString() : '';
                if (!_.contains(elementsIds, element_id) && !isNull(element_id)) {
                  let name = scope.getName(element);
                  let newElement = { id: element.id, name: name, resident_name: element.resident_name, resident_phone: element.resident_phone, resident_email: element.resident_email, resident_external_id: element.resident_external_id };
                  if (scope.modeUser && scope.returnObject) {
                    let user = element.user || element;
                    newElement.first_name = user.first_name;
                    newElement.last_name = user.last_name;
                    newElement.email = user.email;
                  }
                  scope.elementsSelected.push(newElement);
                  elementsIds.push(element_id);
                }
              });
              let valid_results = [];
              angular.forEach(scope.filterValues, function (value) {
                if (_.contains(elementsIds, value)) {
                  valid_results.push(value);
                }
              });
              if (scope.filterValues.length !== valid_results.length) {
                scope.filterValues = valid_results;
                scope.setModelValue();
              } else {
                scope.filterValues = valid_results;
              }
              scope.all = scope.isAllSelected();
              defer.resolve();
            },
            function () {
              defer.resolve();
            }
          );
        } else {
          defer.resolve();
        }
        return defer.promise;
      };

      scope.isOptionDisabled = function (element) {
        const label = scope.getName(element);
        if (scope.validOptions && scope.validOptions.length > 0) {
          return !scope.validOptions.includes(label);
        }
        return false;
      };

      scope.isSelected = function (element) {
        let id = !isNull(element.id) ? element.id.toString() : '';
        let selected = false;
        angular.forEach(scope.elementsSelected, function (value) {
          let element_id = !isNull(value.id) ? value.id.toString() : '';
          if (id === element_id) {
            selected = true;
          }
        });
        return selected;
      };

      scope.isAllSelected = function () {
        return (
          (scope.elementsSelected.length === 0 && scope.clean) ||
          (!isNull(scope.results) && scope.elementsSelected.length === scope.results.length && scope.results.length > 1)
        );
      };

      scope.resetValueAux = function () {
        if (scope.reset) {
          scope.value_aux = '';
        }
        scope.reset = true;
      };

      scope.focusInput = function () {
        if (!scope.inputVisible) {
          scope.inputVisible = true;
          $timeout(function () {
            elem.find('input.input-text')[0].focus();
            scope.resetValueAux();
          });
        }
      };

      scope.getResults = function () {
        if (!scope.service || scope.disabled) {
          return;
        }
        let defer = $q.defer();
        let params = scope.serviceParams ? angular.copy(scope.serviceParams) : {};
        params.page = scope.page;
        params.limit = 25;
        params.essential = true;
        params.noerror = true;
        params.search = scope.value_aux || null;
        scope.reset = false;
        scope.serviceFunction = scope.serviceFunction || scope.service.getlist;
        scope.serviceFunction(params, true).then(function (data) {
          if (scope.page > 1) {
            let oldOptions = angular.copy(scope.options);
            scope.options = oldOptions.concat(data.results || data);
            scope.limitResults += 25;
          } else {
            scope.options = data.results || data;
            scope.limitResults = 25;
          }
          if(scope.label == 'Client Instance' && scope.removeItem && scope.options && scope.options.length > 0){
            scope.options = scope.options.filter((item) => { return item.name != scope.removeItem});
          }
          if (!isNull(data.meta) && !isNull(data.meta.count)) {
            scope.totalElements = data.meta.count;
          }
          else {
            scope.totalElements = !isNull(data.count) ? data.count : scope.options.length;
          }
          defer.resolve();
        });
        return defer.promise;
      };

      scope.setModelValue = function ($event, skipFilter) {
        let results = !isNull(scope.filterValues) ? scope.filterValues.join(',') : null;
        if (scope.mode === 'array') {
          let array = [];
          angular.forEach(scope.elementsSelected, function (result) {
            if (scope.returnObject) {
              array.push(result);
            } else {
              array.push(result.id.toString());
            }
          });
          scope.ngModelCtrl.$setViewValue(array.length > 0 ? array : undefined);
          if (scope.filter && !skipFilter) {
            FilterService.setFilter(scope.filter, array);
          }
        } else if (scope.returnObject) {
          scope.ngModelCtrl.$setViewValue(!isNull(scope.elementsSelected) ? scope.elementsSelected : undefined);
          if (scope.filter && !skipFilter) {
            FilterService.setFilter(scope.filter, scope.elementsSelected);
          }
        } else {
          scope.ngModelCtrl.$setViewValue(!isNull(results) ? results : undefined);
          if (scope.filter && !skipFilter) {
            FilterService.setFilter(scope.filter, results);
          }
        }
        if ($event) {
          scope.ngChange();
          $event.preventDefault();
          $event.stopPropagation();
        }
      };

      scope.addElement = function (element, $event) {
        scope.click = true;
        scope.scroll = elem.find('.widget-combo-list').scrollTop();
        if (scope.disabled || scope.isOptionDisabled(element)) {
          return;
        }
        let id = element.id.toString();
        if (_.contains(scope.filterValues, id)) {
          scope.removeElement(element, $event);
          return;
        }
        if (scope.noMultiple) {
          scope.elementsSelected = [];
          scope.filterValues = [];
          scope.elementsSelected.push(element);
          scope.filterValues.push(id);
        } else {
          if (scope.clean && scope.all) {
            scope.elementsSelected = [];
          }
          scope.elementsSelected.push(element);
          scope.filterValues.push(id);
        }
        scope.all = scope.isAllSelected();

        if (scope.all && scope.clean) {
          scope.filterValues = [];
        }

        if (scope.noMultiple || scope.autoClose) {
          scope.comboListVisible = false;
          scope.inputVisible = false;
          scope.reset = true;
        }

        if (!scope.service) {
          scope.options_results = $filter('contains')('', scope.results);
          if (scope.groups) {
            scope.initGroups(scope.options.results ? scope.options.results : scope.options);
          }
          scope.value_aux = '';
        }

        scope.setModelValue($event);
        $timeout(function () {
          if (!scope.service) {
            elem.find('input.input-text')[0].focus();
            scope.resetValueAux();
          }
        });
      };

      scope.removeElement = function (element, $event) {
        if (scope.disabled || element.required) {
          return;
        }
        if (scope.required && scope.elementsSelected.length <= 1 && !scope.allowUncheck) {
          return;
        }
        let indexSelected = -1;
        angular.forEach(scope.elementsSelected, function (selected, index) {
          if (selected.id === element.id) {
            indexSelected = index;
          }
        });
        if (indexSelected < 0) {
          return;
        }
        scope.elementsSelected.splice(indexSelected, 1);
        scope.filterValues.splice(scope.filterValues.indexOf(element.id.toString()), 1);

        if (scope.noMultiple || scope.autoClose) {
          scope.comboListVisible = false;
          scope.inputVisible = false;
          scope.reset = true;
        }
        scope.all = scope.isAllSelected();

        scope.setModelValue($event);
        $timeout(function () {
          if (!scope.service) {
            elem.find('input.input-text')[0].focus();
            scope.resetValueAux();
          }
        });
      };

      scope.selectAll = function ($event) {
        scope.elementsSelected = [];
        scope.filterValues = [];
        if (!scope.all) {
          angular.forEach(scope.results, function (value) {
            scope.elementsSelected.push(value);
            if (!scope.clean) {
              scope.filterValues.push(value.id.toString());
            }
          });
        }
        scope.all = scope.isAllSelected();

        if (scope.noMultiple || scope.autoClose) {
          scope.comboListVisible = false;
          scope.inputVisible = false;
          scope.reset = true;
        }

        scope.setModelValue($event);
        $timeout(function () {
          if (!scope.service) {
            elem.find('input.input-text')[0].focus();
            scope.resetValueAux();
          }
        });
      };

      scope.initValues = function (defaultValue) {
        scope.filterValues = [];
        if (!isNull(defaultValue)) {
          if (angular.isArray(defaultValue)) {
            let array1 = [];
            angular.forEach(defaultValue, function (value) {
              array1.push(value.id ? value.id.toString() : value.toString());
            });
            scope.filterValues = array1;
          } else {
            let defaultVal = defaultValue.id || defaultValue;
            scope.filterValues = defaultVal.toString().split(',');
          }
        } else if (scope.filter && FilterService.hasFilter(scope.filter)) {
          if (angular.isArray(FilterService.getFilter(scope.filter))) {
            let array = [];
            angular.forEach(FilterService.getFilter(scope.filter), function (value) {
              array.push(value.toString());
            });
            scope.filterValues = array;
          } else {
            scope.filterValues = FilterService.getFilter(scope.filter).toString().split(',');
          }
        } else if (!isNull(scope.defaultValues)) {
          if (angular.isArray(scope.defaultValues)) {
            let array1 = [];
            angular.forEach(scope.defaultValues, function (value) {
              array1.push(value.id ? value.id.toString() : value.toString());
            });
            scope.filterValues = array1;
          } else {
            let defaultVal = scope.defaultValues.id || scope.defaultValues;
            scope.filterValues = defaultVal.toString().split(',');
          }
        }
        let values_valid = [];
        angular.forEach(scope.filterValues, function (value) {
          if (!isNull(value)) {
            values_valid.push(value.toString());
          }
        });
        scope.filterValues = values_valid;
      };

      scope.setDefaultValues = function (defaultValue) {
        let defer = $q.defer();
        $q.when(scope.options).then(function (data) {
          if (data) {
            scope.results = scope.parseOptions(data.results || data);
          } else {
            scope.results = [];
          }
          scope.initValues(defaultValue);
          scope.initOptions();
          if (scope.service) {
            scope.initElementsSelectedService().then(function () {
              defer.resolve();
            });
          } else {
            scope.initElementsSelected(scope.results);
            defer.resolve();
          }
        });
        $q.when(defer.promise).then(function () {
          if (scope.init_options || (!isNull(scope.service) && !isNull(defaultValue))) {
            scope.setModelValue(null, true);
          }
          if (scope.service) {
            $rootScope.$broadcast('select-multiple:initialized', scope.name);
          }
          scope.ngModelCtrl.$validate();
        });
      };

      scope.$watch('options', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue) || !scope.init_options) {
          if (angular.isArray(newValue)) {
            scope.setDefaultValues();
          }
        }
      });

      scope.$watch('defaultValues', function (newValue) {
        let newVal = null;
        if (angular.isArray(newValue)) {
          newVal = newValue.join(',');
        }
        else {
          newVal = !isNull(newValue) ? newValue : null;
        }
        let ngModel = angular.isArray(scope.ngModelCtrl.$modelValue) ? scope.ngModelCtrl.$modelValue.join(',') : scope.ngModelCtrl.$modelValue;
        if (isNull(newVal) && isNull(ngModel)) {
          return;
        }
        if (isNull(ngModel) || (!isNull(newVal) && newVal.toString() !== ngModel.toString())) {
          if (scope.mode === 'array') {
            if (!angular.equals(scope.filterValues, newValue)) {
              scope.setDefaultValues(newValue);
            }
          } else {
            if (!angular.equals(scope.filterValues.join(','), newVal)) {
              if (scope.service) {
                scope.modelChanged = !scope.click;
              }
              $timeout(function () {
                scope.setDefaultValues(newValue);
              }, 100);
            }
          }
        }
      });

      scope.$watch('ngModelCtrl.$modelValue', function (newValue, oldValue) {
        let newVal = null;
        if (angular.isArray(newValue)) {
          newVal = newValue.join(',');
        }
        else {
          newVal = !isNull(newValue) ? newValue : null;
        }
        let oldVal = null;
        if (angular.isArray(oldValue)) {
          oldVal = oldValue.join(',');
        }
        else {
          oldVal = !isNull(oldValue) ? oldValue : null;
        }
        if (isNull(newVal) && isNull(oldVal) || scope.externalValidationError) {
          return;
        }
        if (isNull(newVal) || isNull(oldVal) || newVal.toString() !== oldVal.toString()) {
          if (scope.mode === 'array') {
            if (!angular.equals(scope.filterValues, newValue)) {
              scope.setDefaultValues(newValue);
            }
          } else {
            if (!angular.equals(scope.filterValues.join(','), newVal)) {
              if (scope.service) {
                scope.modelChanged = !scope.click;
              }
              $timeout(function () {
                scope.setDefaultValues(newValue);
              }, 100);
            }
          }
          scope.ngModelCtrl.$validate();
        }
      });

      scope.$watch('serviceParams', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          scope.page = 1;
          scope.getResults();
        }
      }, true
      );

      scope.$on('filter-service:filter-changed', function ($event, key, value) {
        if (scope.filter === key) {
          if (!angular.equals(value, scope.ngModelCtrl.$viewValue)) {
            scope.setDefaultValues();
          }
        }
      });

      scope.$on('filter-service:filter-removed', function ($event, key) {
        if (scope.filter === key) {
          if (!isEmpty(scope.ngModelCtrl.$viewValue)) {
            scope.filterValues = [];
            scope.elementsSelected = [];
            scope.ngModelCtrl.$setViewValue(undefined);
          }
        }
      });

      $timeout(function () {
        scope.$watch('value_aux', function (newValue, oldValue) {
          if (!angular.equals(newValue, oldValue)) {
            if ((!isNull(newValue) || scope.options_results.length > 0) && !scope.comboListVisible && scope.inputVisible) {
              scope.toggleComboList();
            }
            if (scope.service) {
              scope.page = 1;
              scope.getResults();
            } else {
              scope.options_results = $filter('contains')(newValue, scope.results);
              scope.totalElements = scope.options_results.length;
              if (scope.groups) {
                scope.initGroups(scope.options.results ? scope.options.results : scope.options);
                angular.forEach(scope.options_groups, function (group) {
                  group.elements = $filter('contains')(newValue, group.elements);
                });
              }
            }
          }
        });
      }, 20);

      elem.find('input').bind('keydown keypress', function (event) {
        if (event.keyCode === 13) {
          if (scope.options_results.length > 0) {
            scope.addElement(scope.options_results[0], event);
            scope.$apply();
          }
          event.preventDefault();
        }
        if (event.keyCode === 9) {
          $timeout(function () {
            scope.comboListVisible = false;
            scope.$apply(scope.comboListVisible);
            scope.inputVisible = false;
            scope.$apply(scope.inputVisible);
            scope.reset = true;
            scope.$apply(scope.reset);
          }, 10);
        }
      });

      elem.find('.widget-combo-list').scroll(function () {
        if (scope.click) {
          elem.find('.widget-combo-list').animate({ scrollTop: scope.scroll }, 0);
          $timeout(function () {
            scope.click = false;
          }, 0);
        }
      });

      scope.onDocumentClick = function (event) {
        let combo = elem.find('.wrapper-combo');
        let isChild = combo.find(event.target).length > 0;
        if (!isChild && (scope.comboListVisible || scope.inputVisible)) {
          scope.comboListVisible = false;
          scope.$apply(scope.comboListVisible);
          scope.inputVisible = false
          scope.$apply(scope.inputVisible);
          scope.scroll = 0
          scope.$apply(scope.scroll);
          scope.limitGroups = 5;
          scope.$apply(scope.limitGroups);
          scope.limitResults = 25
          scope.$apply(scope.limitResults);
          scope.page = 1;
          scope.$apply(scope.page);
          scope.reset = true;
          scope.$apply(scope.reset);
          scope.click = false;
          scope.$apply(scope.click);
          scope.value_aux = '';
          scope.$apply(scope.value_aux);
          scope.$apply(scope.getResults());
        }
      };

      $document.bind(scope.clickEvent, scope.onDocumentClick);

      scope.ngModelCtrl.$validators.required = function (modelValue) {
        if (!scope.required) {
          return true;
        }
        if (!isNull(modelValue)) {
          if (angular.isArray(modelValue)) {
            return modelValue.length > 0 ? true : false;
          } else {
            return !isNull(modelValue) ? true : false;
          }
        } else {
          return scope.all;
        }
      };

      angular.forEach(scope.validations, function (validator){
        if (validator.async) {
          scope.ngModelCtrl.$asyncValidators[validator.error] = function () {
            return validator.validation().then(function (result) {
              scope.externalValidationError = !result;
              return result;
            });
          };
        }
        else {
          scope.ngModelCtrl.$validators[validator.error] = function () {
            var result = validator.validation();
            scope.externalValidationError = !result;
            return result;
          };
        }
        if (validator.eventWatch) {
          scope.$on(validator.eventWatch, function () {
            scope.ngModelCtrl.$validate();
          });
        }
      });

      elem.on('$destroy', function () {
        $document.unbind(scope.clickEvent);
      });

      scope.setDefaultValues();
    }
  };
};

app.directive('formSelectMultiple', ['$document', '$filter', '$q', '$rootScope', '$timeout', 'FilterService', 'UtilityService', FormSelectMultiple]);
